import React, {useContext,useEffect} from 'react'
import {dataContext,localestr,toText,allTypes} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import UniTable from '../cmp/UniTable.js';

function CatCertificatesEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabClose=actions.tabClose
    const tabNew=actions.tabNew

    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg
    const loaddata=context.loaddata
    const sysConst=context.data['sysConst']

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if(name==='account'||name==='article'||name==='payType'||name==='sum_am'||name==='sum_bal') newData={...wndData,edit_doc:true}
        if(name==='sum_am'){
            newData['sum_bal']=data
        }
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const saveValue=()=>{
        let errmsg=''
        const code=(wndData.code || '').substring(0,15)
        const start=wndData.start || (new Date()).toISOString().substring(0,10)
        const finish=wndData.finish || null
        if(wndData.edit_doc){
            if (!wndData.payType) errmsg=localestr("Не заповнено вид оплати")
            if (!parseFloat(wndData.sum_am||0)||!parseFloat(wndData.sum_bal||0)) errmsg=localestr("Не заповнено суми")
        }

        if (code===null || code==='') errmsg=localestr("Не заповнено код")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            let id=wndData.id
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'CatCertificates',data:{name:code,code,start,finish}}
                saveData(newData,saveDoc)
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'CatCertificates',data:{id,name:code,code,start,finish}}
                saveData(newData,saveDoc)
            }        
            else saveDoc({data:{id:wndData.id}})
        }

    }

    const saveDoc=(d)=>{
        console.log(d)
        let data={}
        if(wndData.edit_doc){
            data.header={author:wndData.author,account:wndData.account,article:wndData.article,payType:wndData.payType,cert:d.data,amount:wndData.sum_am,balance:wndData.sum_bal}
            data.header.act='post'
            if(!wndData.account) data.header.account={id:'NULL'}
            else if(!wndData.account.id) data.header.account={id:'NULL'}
            if(!wndData.article) data.header.article={id:'NULL'}
            else if(!wndData.article.id) data.header.article={id:'NULL'}
            if(!wndData.author) data.header.author={id:'NULL'}
            loaddata('action=modRefillCert&data='+JSON.stringify(data),undefined,()=>{})
        } 
        tabClose()
    }

    const after_save=(d)=>{
        if(d && d.data) setWndData({...wndData,docs:d.data})
        else loaddata('action=docCerts&data='+wndData.id,null,after_save)
    }

    const newRefill=()=>{
        tabNew('docRefillCert_edit',localestr('Поповнення')+' *',{date:(new Date()).toISOString().substring(0, 19)+'Z',author:context.user,account:{id:sysConst.constCashbox},payType:'0',cert:{id:wndData.id,name:wndData.name},edit:true,update:()=>after_save()})
    }

    const newNull=()=>{
        tabNew('docNullifyCert_edit',localestr('Списання')+' *',{date:(new Date()).toISOString().substring(0, 19)+'Z',author:context.user,cert:{id:wndData.id,name:wndData.name},sum_bal:wndData.sum_bal||0,edit:true,update:()=>after_save()})
    }

    const openDoc=()=>{
        if(!wndData.currentCol) return
        if(wndData.currentCol.kind==='docRefillCert') tabNew('docRefillCert_list',localestr('Журнал поповнень'),{currentCol:{...wndData.currentCol}})
        if(wndData.currentCol.kind==='docNullifyCert') tabNew('docNullifyCert_list',localestr('Журнал списань'),{currentCol:{...wndData.currentCol}})
        }

    const cols=[
        {caption:' №',minWidth:'40',maxWidth:'65',dataId:'id',sortable:true},
        {caption:localestr('Дата'),minWidth:'75',maxWidth:'150',dataId:'date',sortable:true},
        {caption:localestr('Документ'),minWidth:'75',dataId:'kind_',sortable:true},
        {caption:localestr('Сума'),minWidth:'45',dataId:'sum',sortable:true},
    ]

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (wndData.docs) list=wndData.docs.map((item)=>{
            const newItem={id:item.id,date:item.date,sum:item.amount,kind:item.kind}
            const idx=allTypes.findIndex(el=>el.value===item.kind)
            if(idx!==-1) newItem.kind_=allTypes[idx].caption_edit
            if(item.kind==='docOrder') newItem.kind_=localestr('Оплата')
            //const newItem={...item}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol({...newItem})
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col==='date') {
                vala=(a[col])
                valb=(b[col])
            } else if(col.substring(0,4)==='sum_') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
    }

    const anyKey=(key)=>{
        //if(key==='Delete') removeItem()
        //else if(key==='Insert') newItem()
        //else if(key==='F9') copyItem()
        if(key==='shift_F4') tabClose()
        //else if(key==='F2') filter()
    }

    useEffect(() => {
        //console.log('effect1')
        //if (typeof table === 'undefined') loadData()
        if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('date','asc',undefined)
    // eslint-disable-next-line 
    },[wndData.docs])

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    
    let cont=null
    if(!wndData.id) cont=<>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={localestr('Каса')} Value={wndData.account} typeVal={'catCashAccs'} setVal={(d)=>{setValue('account',d)}} width1='36' width2='125' />
            <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Стаття')} Value={wndData.article} typeVal={'catArticles'} setVal={(d)=>{setValue('article',d)}} width1='46' width2='125' />
        </div>
        <EditCtrl Capt={localestr('Вид оплати')} Value={wndData.payType} typeVal={'selPayTypes'} setVal={(d)=>{setValue('payType',d)}} width1='98' width2='242' />
        <EditCtrl Capt={localestr('Сума, отриманих коштів')} Value={wndData.sum_am} typeVal={'number2'} setVal={(d)=>{setValue('sum_am',d)}} width1='254' width2='86' />
        <EditCtrl Capt={localestr('Сума, на яку поповнюється баланс')} Value={wndData.sum_bal} typeVal={'number2'} setVal={(d)=>{setValue('sum_bal',d)}} width1='254' width2='86' />
    </>
    else cont=<>
    <div style={{margin:'2px 0',display:'inherit',maxWidth:'678px'}}>
    <div style={{width:'100px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{newRefill()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>Поповнити</div></div>
    <div style={{width:'95px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{newNull()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>Списати</div></div>
    </div>
    <div style={{height:'100%',maxWidth:'678px'}}>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={null} filtArr={null} showFilter={false} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={()=>{openDoc()}} keyHandle={anyKey} setFilter={()=>{}}/>

    </div>
    </>


    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000',height:'100%'}}>
    <div style={{margin:'2px 0',display:'inherit',maxWidth:'678px'}}>
        <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='19' width2='100' disabled={true}/>
        <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Код')} Value={wndData.code} typeVal={'text'} setVal={(d)=>{setValue('code',d)}} width1='30' width2='180'/>
    </div>
    <div style={{margin:'2px 0',display:'inherit',maxWidth:'678px'}}>
        <EditCtrl Capt={localestr('Дійсний з')} Value={wndData.start} typeVal={'date'} setVal={(d)=>{setValue('start',d)}} width1='75' width2='117'/>
        <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('по')} Value={wndData.finish} typeVal={'date'} setVal={(d)=>{setValue('finish',d)}} width1='20' width2='117'/>

    </div>
    {cont}

    <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default CatCertificatesEdit